import { defineComponent as c, ref as r, onServerPrefetch as l, onMounted as o, watch as f, h as s } from "vue";
import { extractRootHtmlElement as m } from "@scalar-org/vue-render";
import { resolveAndFetchIcon as n } from "./resolveAndFetchIcon.js";
function u(e) {
  e.target instanceof HTMLElement && (e.target.style.visibility = "hidden");
}
const g = c({
  props: ["src", "title", "mask"],
  setup(e) {
    const t = r();
    return l(async () => {
      t.value = await n(e.src);
    }), o(async () => {
      t.value || (t.value = await n(e.src));
    }), f(
      () => e.src,
      async (a) => {
        const i = await n(a);
        i && i !== t.value && (t.value = i);
      }
    ), () => {
      if (t.value) {
        const a = m(t.value);
        if (a.tagName === "svg")
          return s(a.tagName, {
            ...a.properties,
            width: e.size,
            height: e.size,
            class: { ...a.properties.class, ...e.classes },
            innerHTML: a.innerHTML
          });
      }
      return s("img", {
        src: e.src,
        alt: e.title,
        width: e.size,
        height: e.size,
        style: "object-fit: contain;",
        class: e.classes,
        onError: u
      });
    };
  }
});
export {
  g as GuideIcon
};
